const COVID_QUERY_KEY = 'covid';
const COVID_RISK_QUERY_KEY = 'covid-risks';

export { COVID_QUERY_KEY, COVID_RISK_QUERY_KEY };
